import 'client-only';

import { useEffect } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import COOKIE_KEYS from '@/consts/cookieKeys';
import { OFFER_CATEGORIES } from '@/consts/offers';
import { OffersService } from '@/services/offersService/client';
import { type OfferResource } from '@/types/offers';
import { trackEvent, AnalyticsEvent } from '@/utils/analytics';
import cookie from '@/utils/cookies/client';

const useOfferTracking = () => {
  const { brand } = useFlowContext();

  useEffect(() => {
    if (brand) {
      const offerCategory = cookie.get(COOKIE_KEYS.offer);
      const offerSource = cookie.get(COOKIE_KEYS.offerSource);

      if (offerCategory && offerSource) {
        OffersService.getOffer(offerCategory, brand).then(
          ({ offer }: { offer?: OfferResource }) => {
            if (!offer) {
              return;
            }

            trackEvent(AnalyticsEvent.OFFER_COOKIE_SET, {
              id: offer.id,
              brandId: offer.brandId,
              name: offer.name,
              weight: offer.weight,
              startAt: offer.startAt,
              endAt: offer.endAt,
            });

            cookie.get(COOKIE_KEYS.offerSource);
          },
        );
      }
    }
  }, [brand]);
};

const useIntroOfferExclusion = () => {
  const excludeStatesFromFreeOTCOfferVariant = (state: string) => {
    const STATES_TO_EXCLUDE = ['IL'];

    if (STATES_TO_EXCLUDE.includes(state)) {
      // Business logic:
      // Users from this state always get the original free trial offer.
      const offerId = Number(cookie.get(COOKIE_KEYS.offer));

      if (offerId && offerId !== OFFER_CATEGORIES.freeTrial) {
        trackEvent(AnalyticsEvent.OFFER_REASSIGNED);
      }

      cookie.set(COOKIE_KEYS.offer, OFFER_CATEGORIES.freeTrial.toString());
    }
  };

  return { excludeStatesFromFreeOTCOfferVariant };
};

export { useOfferTracking, useIntroOfferExclusion };
